export default __webpack_public_path__ + "images/mob-banner.png";